import AchIcon from "../unit/svgIcon/AchIcon";
import AchPaymentsList from "./AchPaymentsList";
const ACHPaymentIcon = () => {
  return <AchIcon color="white" size="22px" />;
};
export default {
  list: AchPaymentsList,
  icon: ACHPaymentIcon,
};
